<!--
 * @FileDescription: 作业单个附件样式
 * @Author: 刘凯
 * @Date: 2022-02-16 11:00:49
 * @LastEditors: 刘凯
 * @LastEditTime: 2022-03-01 17:57:35
-->
<template>
  <div class="pr text-center mt0-ipmt file-wrap">
    <!-- 删除按钮 -->
    <i
      v-if="showDelete"
      class="file-del w20 h20 right-top mask hand opah0"
      @click="$emit('delete')"
    >
      <yxt-svg
        class="pa pa-center c-f"
        width="20px"
        height="20px"
        icon-class="common_close"
      />
    </i>

    <div
      :style="{ height: imageHeight }"
      class="border-1 border-f5f5f5 border-solid border-box text-center radius4 over-hidden pr hand bg-gray-2"
    >
      <!-- 文件格式错误 展示图标 -->
      <yxt-svg
        v-if="file.upload && file.upload.status === 'failed'"
        width="54px"
        height="52x"
        icon-class="hwk-unknown-file-type"
        :remote-url="svgUrl"
      />
      <!-- zip ,转码失败的文件展示 图标 -->
      <i v-else-if="isDefaultIconUsed" class="wline d-block bg-center hline pr">
        <yxtf-svg
          width="54px"
          height="54px"
          class="pa pa-center"
          :icon-class="'icons/f_kng-' + file.fileSubType"
        />
      </i>
      <template v-else>
        <!-- 使用背景图 -->
        <yxt-image
          v-if="file.viewUrl"
          :src="getFilteredImg(file.viewUrl)"
          fit="contain"
          class="d-block text-8c bg-gray-2 wline hline"
        >
          <div slot="placeholder" class="image-slot font-size-12">
            {{ $t('pc_o2o_lbl_loading') }}
          </div>
          <div slot="error" class="image-slot font-size-24">
            <i class="yxtf-icon-picture-outline"></i>
          </div>
        </yxt-image>
        <!-- 音频转码成功后使用背景图 -->
        <i
          v-if="file.fileType === 'audio' && file.status === 1"
          class="audio-bg d-block wline hline"
        ></i>
      </template>

      <!-- hover 遮罩 -->
      <div
        v-show="!file.upload || file.upload.status === 'success'"
        v-if="['doc', 'image', 'zip', 'audio', 'video'].includes(file.fileType)"
        class="layout-flex layout-align-center layout-justify-center pa right-top mask wline hline opah0 opah1"
      >
        <div
          v-if="file.fileType !== 'zip' && viewBtnIsShow"
          class="h24 layout-flex layout-align-center color-white hand"
          @click="$emit('preview', file)"
        >
          <yxt-tooltip
            :content="$t('pc_biz_imgcropper_btn_preview' /* 预览 */)"
            placement="top"
          >
            <yxt-svg
              class="v-mid mr4"
              width="16px"
              height="16px"
              icon-class="view"
            />
          </yxt-tooltip>
        </div>
        <div
          v-if="downloadBtnIsShow"
          :class="{ ml20: file.fileType !== 'zip' }"
          class="h24 layout-flex layout-align-center color-white hand"
          @click="$emit('download', file)"
        >
          <yxt-tooltip
            :content="$t('pc_biz_import_btn_download\n' /* 下载 */)"
            placement="top"
          >
            <yxt-svg
              class="v-mid mr4"
              width="16px"
              height="16px"
              icon-class="download-center"
            />
          </yxt-tooltip>
        </div>
        <div
          v-if="
            (file.status === 1 || file.fileType === 'image') &&
              joinKnglibBtnIsShow
          "
          class="h24 layout-flex layout-align-center color-white hand ml20 lhnormal"
        ></div>
      </div>

      <div
        v-if="file.upload && file.upload.status === 'uploading'"
        class="pa bottom0 left0 right0"
      >
        <yxt-progress
          :stroke-width="6"
          :percentage="file.upload.progress * 100"
          :fit-width="true"
          :show-text="false"
        />
      </div>
    </div>
    <yxt-tooltip
      v-if="!fileNameHidden"
      open-filter
      :content="file.name"
      placement="top"
    >
      <div class="ellipsis mt8 text-center lh22">{{ file.name }}</div>
    </yxt-tooltip>
    <div v-if="!fileStatusHidden" class="lh20">
      <div class="hline layout-flex layout-align-center layout-justify-center">
        <template v-if="file.upload && file.upload.status === 'failed'">
          <yxt-svg
            class="mr2"
            width="16px"
            height="16px"
            icon-class="message-error"
          />
          <div class="font-size-12 yxtf-color-danger ellipsis">
            {{ file.upload.msg }}
          </div>
        </template>
        <template v-else-if="file.transcode === 'transcoding'">
          <yxt-svg
            class="mr2 flex-shrink-0"
            width="16px"
            height="16px"
            icon-class="o2o-hwk-reference-loading"
          />
          <div class="font-size-12 color-gray-8">
            {{ $t('pc_o2o_transcoding_no_preview' /* 转码中，暂不支持预览 */) }}
          </div>
        </template>
        <template v-else-if="file.transcode === 'failed'">
          <yxt-svg
            class="mr2 color-gray-8"
            width="16px"
            height="16px"
            icon-class="icons/close-circle-o"
          />
          <div class="font-size-12 color-gray-8">
            {{ $t('pc_o2o_lbl_transcodefail' /* 转码失败 */) }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import AttachmentMixin from '../mixins/attachment-mixin.vue';

export default {
  mixins: [AttachmentMixin],
  computed: {
    svgUrl() {
      return `${this.$staticBaseUrl}ufd/55a3e0/o2o/pc/svg`;
    }
  }
};
</script>
